<template>
  <div class="announcement" :class="{ empty: !announcementText }">
    <template v-if="announcementText">
      <i class="fa-solid fa-bullhorn"></i>
      <span>{{ announcementText }}</span>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useAppStore } from '@/store/app'
import { storeToRefs } from 'pinia'

const app = useAppStore()
const { announcement } = storeToRefs(app)
const announcementText = computed(() => announcement?.value ?? '')
defineOptions({ name: 'Announcement' })
</script>

<style scoped lang="scss">
@use 'sass:color';
.announcement {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: $on-elevation1;
  width: 100%;
  font-size: 0.8rem;
  height: 2rem;
  padding: 0 0.5rem;

  &.empty {
    visibility: hidden;
  }
}
</style>
